<template>
	<v-navigation-drawer
		app
		fixed
		temporary
		width="550"
		class="drawer-container-left"
		v-model="openState"
		ref="leftDrawerContainer">

		<template v-if="contentComponent">
			<component :is="contentComponent" :isOpen="openState" />
		</template>

		<template v-else>
			<!-- TODO: Has to be smooshed right after. Yeah, needed but can be loading swirly, etc? -->
			<div>Default Content</div>
		</template>

	</v-navigation-drawer>
</template>


<script>
	import { mapFields } from 'vuex-map-fields'

	export default {
		name: 'drawer-container-left',
		data:() => ({
			contentComponent: null
		}),
		computed: {
			...mapFields({
				openState: 'ui.leftDrawer.openState',
				content: 'ui.leftDrawer.content'
			})
		},
		created() {
			this.loadContent();
		},
		methods: {
			loadContent() {
				this.contentComponent = (this.content) ? this.$root.loadComponent(this.content) : null
			}
		},
		watch: {
			'content': {
				deep: true,
				handler() {
					this.loadContent()
				}
			}
		}
	}
</script>